import React from "react";

export const ShipDirectLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    {/* Enhanced arrow above truck */}
    <path
      d="M12 1.5L16 5.5M16 5.5L12 9.5M16 5.5H8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Original truck elements */}
    <path
      d="M16.25 14.5833C16.25 15.7339 15.3173 16.6667 14.1667 16.6667C13.0161 16.6667 12.0834 15.7339 12.0834 14.5833C12.0834 13.4327 13.0161 12.5 14.1667 12.5C15.3173 12.5 16.25 13.4327 16.25 14.5833Z"
      stroke={color}
      strokeOpacity="0.6"
      strokeWidth="1.5"
    />
    <path
      d="M7.91667 14.5833C7.91667 15.7339 6.98392 16.6667 5.83333 16.6667C4.68274 16.6667 3.75 15.7339 3.75 14.5833C3.75 13.4327 4.68274 12.5 5.83333 12.5C6.98392 12.5 7.91667 13.4327 7.91667 14.5833Z"
      stroke={color}
      strokeOpacity="0.6"
      strokeWidth="1.5"
    />
    <path
      d="M12.0834 14.5835H7.91669M16.25 14.5835H16.886C17.0693 14.5835 17.1609 14.5835 17.2379 14.5739C17.8058 14.5032 18.253 14.0559 18.3238 13.4881C18.3334 13.4111 18.3334 13.3194 18.3334 13.1362V10.8335C18.3334 7.84195 15.9083 5.41683 12.9167 5.41683M12.5 12.9168V5.8335C12.5 4.65499 12.5 4.06573 12.1339 3.69961C11.7678 3.3335 11.1785 3.3335 10 3.3335H4.16669C2.98818 3.3335 2.39892 3.3335 2.0328 3.69961C1.66669 4.06573 1.66669 4.65499 1.66669 5.8335V12.5002C1.66669 13.279 1.66669 13.6684 1.83415 13.9585C1.94386 14.1485 2.10166 14.3063 2.29169 14.416C2.58175 14.5835 2.97117 14.5835 3.75002 14.5835"
      stroke={color}
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
